// Generated by purs version 0.15.4
import * as Control_Bind from "../Control.Bind/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Halogen_Aff_Util from "../Halogen.Aff.Util/index.js";
import * as Halogen_VDom_Driver from "../Halogen.VDom.Driver/index.js";
import * as PartyCarlo_Env from "../PartyCarlo.Env/index.js";
import * as PartyCarlo_Pages_Home from "../PartyCarlo.Pages.Home/index.js";
import * as PartyCarlo_ProdM from "../PartyCarlo.ProdM/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(Effect_Aff.bindAff);
var component = /* #__PURE__ */ PartyCarlo_Pages_Home.component(PartyCarlo_ProdM.monadAffProdM)(PartyCarlo_ProdM.logMessagesProdM)(PartyCarlo_ProdM.nowProdM)(PartyCarlo_ProdM.randomProdM)(PartyCarlo_ProdM.sleepProdM);
var main = /* #__PURE__ */ Halogen_Aff_Util.runHalogenAff(/* #__PURE__ */ bind(Halogen_Aff_Util.awaitBody)(function (body) {
    var initialStore = {
        env: PartyCarlo_Env.env
    };
    return bind(PartyCarlo_ProdM.runProdM(initialStore)(component))(function (root) {
        return Halogen_VDom_Driver.runUI(root)(PartyCarlo_Pages_Home.defaultTextAreaValue)(body);
    });
}));
export {
    main
};
